import * as yup from '@if/core/yup'
import { EInteracWireStatus } from '@src/types/interac'
import { lazyLoad } from '@src/types/lazy'

/** The only two statuses the history endpoint serves — they are the page's tabs. */
export type EInteracHistoryStatus = EInteracWireStatus.Matched | EInteracWireStatus.Discarded

export const getInteracHistoryStatusList = lazyLoad<EInteracHistoryStatus[]>(() => [
  EInteracWireStatus.Matched,
  EInteracWireStatus.Discarded,
])

/**
 * The page's URL-backed filters: `search` drives the shared search bar and `status` the tabs.
 * The search has no mode to pick — see {@link getSearchFilters}.
 */
export const interacHistoryFiltersSchema = yup.object({
  search: yup.text(),
  status: yup.mixed<EInteracHistoryStatus>().oneOf(getInteracHistoryStatusList()).default(EInteracWireStatus.Matched),
})

export type InteracHistoryFiltersType = yup.InferSubmit<typeof interacHistoryFiltersSchema>

const emailSchema = yup.text().email()

/**
 * Splits the one search box across the endpoint's two search fields: a value that is a valid
 * email address searches the sender email, anything else searches the client name. Which one
 * it is is inferred from the value, so there is nothing to pick and nothing to reject.
 */
export const getSearchFilters = ({ search }: InteracHistoryFiltersType) => {
  const value = search?.trim() || null
  const searchesEmail = !!value && emailSchema.isValidSync(value)
  return {
    clientNameContains: searchesEmail ? null : value,
    email: searchesEmail ? value : null,
  }
}
